"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var cashtag = /[a-z]{1,6}(?:[._][a-z]{1,2})?/i;
exports.default = cashtag;
module.exports = exports["default"];